"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GroupComponent = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _AttributeComponent = _interopRequireDefault(require("./AttributeComponent"));
var _storeProvider = require("./../util/storeProvider");
var _information = _interopRequireDefault(require("@ux/icon/information"));
var _common = require("./../util/common");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
class GroupComponent extends _react.PureComponent {
  render() {
    const {
      group: groupName,
      content: groupContent,
      attributes,
      commonContent
    } = this.props;
    const title = {
      __html: groupContent.title
    } || {};
    const description = {
      __html: groupContent.description
    } || {};
    const notifyMesgKey = this.props.layoutProperties.notificationkey; // || 'englishLangProductMesg';

    const filteredAttributes = attributes.filter(attribute => attribute.name !== 'termType').filter(attribute => attribute.name !== 'domainName').filter(attribute => attribute.layoutProperties.display !== 'none').filter(attribute => attribute.layoutProperties.display);
    if (filteredAttributes.length === 0) {
      return null;
    }
    const useCardBlock = !['free_domain'].includes(groupName);
    return /*#__PURE__*/React.createElement("div", {
      className: useCardBlock ? 'card ux-card' : ''
    }, notifyMesgKey && commonContent[notifyMesgKey] && groupName !== 'free_domain' && /*#__PURE__*/React.createElement("div", {
      className: "ms-3 py-1 px-5 card-notify"
    }, /*#__PURE__*/React.createElement(_information.default, {
      width: 12,
      height: 12
    }), /*#__PURE__*/React.createElement("span", {
      className: "card-notify-text mx-2"
    }, commonContent[notifyMesgKey])), /*#__PURE__*/React.createElement("div", {
      className: useCardBlock ? 'card-block' : ''
    }, title.__html && /*#__PURE__*/React.createElement("h3", {
      dangerouslySetInnerHTML: title
    }), description.__html && /*#__PURE__*/React.createElement("p", {
      dangerouslySetInnerHTML: description
    }), filteredAttributes.map(attribute => {
      const enumLength = attribute.enum && attribute.enum.length ? attribute.enum.length : 0;
      const initialVisibleEnums = attribute.layoutProperties.initialVisibleEnums || enumLength;
      const selectedVal = this.context.store.getStateValue(`data.instance.${attribute.instancePath}`);
      return /*#__PURE__*/React.createElement(_AttributeComponent.default, _extends({
        groupContent: groupContent,
        includeState: [{
          path: 'app.postComplete'
        }],
        key: (0, _common.getInstancePathKey)(attribute.instancePath, attribute.propertytype),
        initialVisibleEnums: initialVisibleEnums,
        selectedVal: selectedVal
      }, attribute));
    })));
  }
}
exports.GroupComponent = GroupComponent;
GroupComponent.propTypes = {
  attributes: _propTypes.default.array,
  content: _propTypes.default.object,
  group: _propTypes.default.string,
  layoutProperties: _propTypes.default.object,
  commonContent: _propTypes.default.object
};
var _default = exports.default = (0, _storeProvider.provideContext)(GroupComponent);